import React from 'react';
import { useParams } from 'react-router-dom';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { fmtDateTime } from '../../../../utils/fmt';

const CommunicationLogList = () => {
  const { activityId } = useParams();

  const decodedActivityId = activityId ? atob(activityId).replace(/\D/g, '') : '';
  const fetchUrl = decodedActivityId
    ? `${API_DOMAIN}${API_ROUTES.customerCommunicationLog}?activity=${decodedActivityId}`
    : `${API_DOMAIN}${API_ROUTES.customerCommunicationLog}`;

  const columns = [
    { label: 'Note', value: 'note' },
    { label: 'Timestamp', value: (item) => fmtDateTime(item.timestamp) },
    { label: 'Activity', value: item => item.activity?.subject || 'N/A' },
    { label: 'Logged By', value: item => item.logged_by?.username || 'N/A' },
  ];

  const handleAccessDetails = (id) => {
    window.location.href = `/customer/communication-log/details/${id}`;
  };

  return (
    <div>
      <h1>Communication Logs</h1>
      <ListTemplate
        fetchUrl={fetchUrl}
        columns={columns}
        onAccessDetails={handleAccessDetails}
      />
    </div>
  );
};

export default CommunicationLogList;
